import Vue from 'vue'
import VueRouter from 'vue-router'
// import reportMixin from '@/mixin/reportMixin.js'

// 页面浏览上报由现有 telemetry 链路负责；本服务不启用旧 fingerprint collector。

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
	},
	{
		path: '/names',
		name: 'names',
		component: () => import(/* webpackChunkName: "names" */ '../pages/names.vue'),
	},
	{
		path: '/names/:named/:id',
		name: 'nameDetail',
		component: () => import('../pages/nameDetail.vue'),
	},
	{
		path: '/categories',
		name: 'categories',
		component: () => import(/* webpackChunkName: "categories" */ '../pages/categories.vue'),
	},
	{
		path: '/categories/:cate',
		name: 'categoryDetail',
		component: () => import(/* webpackChunkName: "categoryDetail" */ '../pages/categoryDetail.vue'),
	},
	{
		path: '/categories/:cate/:value',
		name: 'categoryList',
		component: () => import(/* webpackChunkName: "categoryList" */ '../pages/categoryList.vue'),
	},
	{
		path: '/blog',
		name: 'blog',
		component: () => import(/* webpackChunkName: "blog" */ '../pages/blog.vue'),
	},
	{
		path: '/blog/:title/:id',
		name: 'blogDetail',
		component: () => import(/* webpackChunkName: "blogDetail" */ '../pages/blogDetail.vue'),
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: () => import(/* webpackChunkName: "about-us" */ '../pages/about-us.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy-policy.vue'),
	},
	{
		path: '/terms-of-service',
		name: 'terms',
		component: () => import('../pages/terms-of-service.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},

	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
